export const GENDER_MALE = 'm';
export const GENDER_FEMALE = 'f';

export const AGE_MIN_HARD = 13;
export const AGE_MAX_HARD = 65;

export default class CampaignTarget {
  constructor() {
    this.radius = 0;
    this.locations = [];
    this.ages = { from: AGE_MIN_HARD, to: AGE_MAX_HARD };
    this.genders = [GENDER_MALE, GENDER_FEMALE];
    this.interests = [];
    this.language = null;
    this.use_instagram = null; // will be set to the correct initial value by PlacementSelector
  }
}



// WEBPACK FOOTER //
// ./src/models/campaign-target.js